/* eslint eqeqeq: 0 */
export default function (ACTION_TYPE) {
  return (state = {}, action) => {
    if (action.type == ACTION_TYPE) {
      return {
        dateFrom: action.dateFrom,
        dateTo: action.dateTo
      };
    }
    return state;
  };
}
